module.exports = __webpack_public_path__ + "static/media/value-proposition-match@2x.dfff4f17.png";